import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthenticationGuard } from '@vfde-fe/ngx-lib/guards/authentication';
import { CommonCacheService } from '@vfde-fe/ngx-lib/services/common-cache';
import { CoreAuthenticationService } from '@vfde-fe/ngx-lib/services/core-authentication';
import { SimCacheService } from '@vfde-fe/ngx-lib/services/sim-cache';
import { SimService } from '@vfde-fe/ngx-lib/services/sim';
import { AccessGuard } from '@vfde-fe/ngx-lib/guards/access-guard';
import { DisableDeepLinksGuard } from '@vfde-fe/ngx-lib/guards/disable-deeplinks';
import { DisableFeatureGuard } from '@vfde-fe/ngx-lib/guards/disable-feature';
import { ActiveSubscriptionGuard } from '@vfde-fe/ngx-lib/guards/active-subscribtion';
import { SIMAccessGuard } from '@vfde-fe/ngx-lib/guards/sim-access';
import { GuestOnlyGuard } from '@vfde-fe/ngx-lib/guards/guest-only';
import { UserCacheService } from '@vfde-fe/ngx-lib/services/user-cache';
import { ContractCacheService } from '@vfde-fe/ngx-lib/services/contract-cache';
import { SubscriptionCacheService } from '@vfde-fe/ngx-lib/services/subscription-cache';
import { AuthenciatoinServiceProvider } from '@vfde-fe/ngx-lib/services/core-authentication';
import { ConfirmDeactivateGuard } from '@vfde-fe/ngx-lib/guards/confirm-deactivate';
import { DXLAuthenticationService } from '@vfde-fe/ngx-lib/services/dxl-authentication';
import { TerminationCheckGuard } from '@vfde-fe/ngx-lib/guards/termination';
import { TokenService } from '@vfde-fe/ngx-lib/services/token';

/** modules  */
@NgModule({
    imports: [CommonModule],
    providers: [
        CoreAuthenticationService,
        SimService,
    ],
})
/** AuthModule */
export class AuthModule {
/** forRoot */
  public static forRoot (obj?: AuthenciatoinServiceProvider): ModuleWithProviders<unknown> {
        return {
            ngModule: AuthModule,
            providers: [
                CommonCacheService,
                UserCacheService,
                ContractCacheService,
                SubscriptionCacheService,
                SimCacheService,
                obj ? obj : CoreAuthenticationService,
                SIMAccessGuard,
                AuthenticationGuard,
                AccessGuard,
                DisableDeepLinksGuard,
                DisableFeatureGuard,
                ActiveSubscriptionGuard,
                GuestOnlyGuard,
                ConfirmDeactivateGuard,
                TerminationCheckGuard,
                DXLAuthenticationService,
                TokenService,
            ],
        };
    }
}
